// @ts-nocheck
import { SP } from "./namespace";
import { spellTipHTML, spellDescDetail, escapeHtml } from "../client";
import { Tip as TextTip, passiveTipHTML, tipContextFromEl, tipHTMLForEl } from "../game/net-ui";

SP.hideDraftHover = function () {
  SP.Tip.hide();
  SP.SimTip.hide();
  TextTip.hide();
};

SP.showDraftHover = function (block, x, y) {
  TextTip.hide();
  SP.Tip.hide();
  SP.SimTip.hide();

  const kind = block.getAttribute("data-tip-kind");
  const tipId = block.getAttribute("data-tip-id");
  const spellId = block.getAttribute("data-tip-spell") || tipId;
  const synergyId = block.getAttribute("data-synergy-preview");

  if (synergyId) {
    if (SP.isEnabled?.() && SP.useSynergyPreview?.(synergyId) &&
        SP.SimTip.showSynergy(spellId, synergyId, x, y, block)) {
      return;
    }
    TextTip.show(passiveTipHTML(spellId, synergyId, tipContextFromEl(block)), x, y);
    return;
  }

  if (kind === "spell" && tipId) {
    const slot = block.getAttribute("data-tip-slot") || undefined;
    if (SP.isEnabled?.() && SP.has?.(tipId) && SP.Tip.show(tipId, x, y, slot)) {
      return;
    }
    TextTip.show(spellTipHTML(tipId, slot), x, y);
    return;
  }

  if (kind === "passive" && tipId) {
    const spellDesc = spellId ? spellDescDetail(spellId) : "";
    const tip = tipHTMLForEl(block);
    const spellBlurb = spellDesc
      ? `<div class="tip-desc tip-desc-host-spell">${escapeHtml(spellDesc)}</div>`
      : "";
    TextTip.show(tip + spellBlurb, x, y);
  }
};

SP.moveDraftHover = function (x, y) {
  if (SP.SimTip.spellId || SP.SimTip.passiveId) SP.SimTip.move(x, y);
  else if (SP.Tip.spellId) SP.Tip.move(x, y);
  else TextTip.move(x, y);
};

SP.wireDraftPanel = function () {
  const draft = document.getElementById("draft");
  if (!draft || draft.dataset.draftPreviewWired) return;
  draft.dataset.draftPreviewWired = "1";

  let current = null;
  document.addEventListener("mousemove", (e) => {
    if (draft.classList.contains("hidden")) {
      if (current) { current = null; SP.hideDraftHover(); }
      return;
    }
    if (window.game?.overActionBarTip?.(e.clientX, e.clientY)) {
      if (current) { current = null; SP.hideDraftHover(); }
      return;
    }
    if (TextTip.isOver(e.clientX, e.clientY)) return;
    const block = (e.target as Element | null)?.closest("#draftCards .draft-pick-block");
    const overPopover = SP.isOverPreviewPopover(e.clientX, e.clientY);

    if (!block) {
      if (!overPopover && current) { current = null; SP.hideDraftHover(); }
      return;
    }

    if (block !== current) {
      current = block;
      SP.showDraftHover(block, e.clientX, e.clientY);
    } else {
      SP.moveDraftHover(e.clientX, e.clientY);
    }
  });
};
